import React from "react";
import "./Testimonial.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import { Pagination } from "swiper";
import "swiper/css/pagination";
import profilePic1 from "../../img/profile1.jpg";
import profilePic2 from "../../img/profile2.jpg";
import profilePic3 from "../../img/profile3.jpg";
import profilePic4 from "../../img/profile4.jpg";

const Testimonial = () => {
  const clients = [
    {
      img: "",
      review:
        "Rahul has done a great job. He is truly excellent in his field! I really appreciate his fast response for every request or query.",
    },
    {
      img: "",
      review:
        "I am greatful to have you in my team. You never late for work. And never face any issue with your work. Good Work!!",
    },
    {
      img: "",
      review:
        "Rahul is an excellent team worker and a absolute beast in learning new skill and upliftment. He worked under my leadership for over 1+ year and he excelled at all the challenges that were put up to him.",
    },
  ];

  return (
    <div className="t-wrapper" id="testimonial">
      <div className="t-heading">
        <span>Clients always get </span>
        <span>Exceptional Work </span>
        <span>from me...</span>
      <div className="blur t-blur1" style={{ background: "var(--purple)" }}></div>
      <div className="blur t-blur2" style={{ background: "skyblue" }}></div>

      </div>
      <Swiper
        // install Swiper modules
        modules={[Pagination]}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {clients.map((client, index) => {
          return (
            <SwiperSlide key={index}>
              <div className="testimonial">
                <div style={{width:"5rem", height:"5rem", backgroundColor:"lightgrey",marginBottom:"1.5rem", borderRadius:"50%"}} src="" alt="" />
                <span>{client.review}</span>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Testimonial;
